import { render, staticRenderFns } from "./createFuncionario.vue?vue&type=template&id=13fb6860&scoped=true&"
import script from "./createFuncionario.vue?vue&type=script&lang=js&"
export * from "./createFuncionario.vue?vue&type=script&lang=js&"
import style0 from "./createFuncionario.vue?vue&type=style&index=0&id=13fb6860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fb6860",
  null
  
)

export default component.exports